import React from "react";
import { connect } from "react-redux";
import { ActivityFormQuizContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { withTranslation } from "react-i18next";
import { userService } from "apiServices";
import { ROUTE_PATH } from "utils/constants/routePath";
import { toast } from "react-toastify";
import ActivityFormQuizNoMemberContainer from "./ActivityFormQuizNoMemberContainer";
import { HeaderBackHomeWidget } from "widgets";
import { Displays, Forms, Navigations } from "components";

class ActivityFormQuizContainer extends React.Component {
  state = {
    isLoading: true,
    activePage: 0,
    step: 1,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { router } = this.props;
    const locationSplit = router.location.pathname.split("/");
    const isNoMember = !locationSplit.some((e) => e === "system");
    let resArr = await Promise.all([
      userService.GET_ACTIVITY_FORM_PDPA_DETAIL(router.params?.id),
      router.params?.question_id !== "create"
        ? userService.GET_MY_ACTIVITY_FORM_DETAIL(router.params?.question_id)
        : false,
    ]);
    // ตอน error axios คืน response กลับมา ซึ่ง data เป็น { error: {...} } ไม่ใช่ตัวฟอร์ม
    // ต้องเช็ค question_list ก่อน ไม่งั้น .map() พังตอน draft ถูกลบ/หมดอายุ
    const historyData =
      resArr[1] && Array.isArray(resArr[1]?.data?.question_list)
        ? resArr[1].data
        : null;
    if (resArr && resArr[0].status === 200) {
      if (
        router.params?.question_id !== "create" &&
        !historyData &&
        router.params?.action === "update"
      ) {
        // draft ของ no-member มีอายุ 1 วัน หมดแล้วให้เริ่มกรอกใหม่ ไม่ปล่อยให้ค้างหน้าเปล่า
        this.setState({
          data: {
            ...resArr[0].data,
            question_list: resArr[0].data.question_list.sort(
              (a, b) => a.page - b.page,
            ),
          },
        });
        this.handleExpired();
        return;
      }
      if (historyData) {
        const sortData = {
          ...resArr[0].data,
          question_list: resArr[0].data.question_list.sort(
            (a, b) => a.page - b.page,
          ),
        };
        this.setState({
          initialValue: {
            ...historyData,
            question_list: historyData.question_list.map((e, i) => ({
              ...e,
              questions: e.questions.map((f, j) => {
                let render = f;
                if (f.type === "4") {
                  render.pdpa_details =
                    sortData.question_list[i].questions[j].pdpa_details;
                }
                return render;
              }),
            })),
          },
          data: sortData,
          step: isNoMember ? 2 : 1,
          isLoading: false,
        });
      } else {
        this.setState({
          data: {
            ...resArr[0].data,
            question_list: resArr[0].data.question_list.sort(
              (a, b) => a.page - b.page,
            ),
          },
          isLoading: false,
        });
      }
    }
  };

  handlePersonalSubmit = async (values) => {
    const { authenRedux, router } = this.props;
    switch (router.params.action) {
      case "view":
        this.setState({
          step: 2,
        });
        break;
      case "update":
        if (router.params?.question_id !== "create") {
          this.setState({
            step: 2,
          });
        } else {
          this.setState({
            isBgLoading: true,
          });
          let params = {
            ...values,
            activity_form_id: router.params?.id,
            member_type: values.member_type || authenRedux.member_type_active,
          };
          let res =
            values.member_type === "3"
              ? await userService.POST_ACTIVITY_FORM_HISTORY_REGISTER_PERSONAL_INFO_NO_MEMBER(
                  params,
                )
              : await userService.POST_ACTIVITY_FORM_HISTORY_REGISTER_PERSONAL_INFO(
                  params,
                );
          if (res && res.status === 200) {
            this.props.router.navigate(
              `${
                values.member_type === "3"
                  ? ROUTE_PATH.ACTIVITY_FORM_NO_LOGIN
                  : ROUTE_PATH.ACTIVITY_FORM
              }/${router.params?.id}/quiz/${res.data._id}/${
                router.params?.action
              }`,
            );
            this.setState({
              tempPersonal: values,
              step: 2,
              isBgLoading: false,
            });
          } else {
            this.setState({
              isBgLoading: false,
            });
            toast.error(this.props.t("Registration failed. Please check conditions.", { ns: "common" }));
          }
        }
        break;
      default:
        break;
    }
  };

  // ร่างหมดอายุ/ถูกลบแล้ว พากลับไปหน้าเริ่มกรอกใหม่ (no-member ต้องยืนยัน OTP ใหม่)
  // route เดิม เปลี่ยนแค่ param จึงไม่ remount ต้อง reset state เองด้วย
  handleExpired = () => {
    const { router } = this.props;
    const locationSplit = router.location.pathname.split("/");
    const isNoMember = !locationSplit.some((e) => e === "system");
    toast.error(
      this.props.t("This form has expired. Please fill it in again.", {
        ns: "activity",
      }),
    );
    this.props.router.navigate(
      `${
        isNoMember ? ROUTE_PATH.ACTIVITY_FORM_NO_LOGIN : ROUTE_PATH.ACTIVITY_FORM
      }/${router.params?.id}/quiz/create/update`,
    );
    this.setState({
      initialValue: undefined,
      tempValues: undefined,
      activePage: 0,
      step: 1,
      isLoading: false,
      isBgLoading: false,
    });
  };

  handleBack = () => {
    const { activePage, tempValues } = this.state;
    this.setState({
      isLoading: true,
    });
    setTimeout(() => {
      let temp = false;
      let find =
        tempValues &&
        tempValues[activePage - 1].questions.find(
          (e) => e.jumpToBack || e.jumpToBack === 0,
        );
      if (find) {
        temp = find.jumpToBack;
      }
      this.setState({
        activePage: !temp && temp !== 0 ? activePage - 1 : temp,
        isLoading: false,
      });
    }, 500);
  };
  handleSubmit = async (values) => {
    const { router } = this.props;
    const { activePage, data, tempValues } = this.state;
    const locationSplit = router.location.pathname.split("/");
    const isNoMember = !locationSplit.some((e) => e === "system");
    const _updateTemp = (masterTempValue, currentValues, jumpToPart) => {
      let temp = masterTempValue;
      const clearData = currentValues.questions.map((e) => {
        let tempValues = e;
        tempValues.is_skip = false;
        delete tempValues.jumpToBack;
        return tempValues;
      });
      if (!temp) {
        temp = [
          {
            title: data.question_list[activePage].title,
            desc: data.question_list[activePage].desc,
            page: data.question_list[activePage].page,
            questions: clearData,
          },
        ];
      } else {
        if (temp[activePage]) {
          temp[activePage] = {
            title: data.question_list[activePage].title,
            desc: data.question_list[activePage].desc,
            page: data.question_list[activePage].page,
            questions: clearData,
          };
        } else {
          temp.push({
            title: data.question_list[activePage].title,
            desc: data.question_list[activePage].desc,
            page: data.question_list[activePage].page,
            questions: clearData,
          });
        }
      }
      if (jumpToPart) {
        for (let index = activePage + 1; index < jumpToPart - 1; index++) {
          if (!temp[index]) {
            temp.push({
              title: data.question_list[index].title,
              desc: data.question_list[index].desc,
              page: data.question_list[index].page,
              questions: data.question_list[index].questions.map((e) => ({
                ...e,
                is_skip: true,
                jumpToBack: activePage,
              })),
            });
          } else {
            temp[index].questions = data.question_list[index].questions.map(
              (e) => ({
                ...e,
                is_skip: true,
                jumpToBack: activePage,
              }),
            );
          }
        }
      }
      return temp;
    };
    // PROCESS
    // =====================================
    // =====================================
    this.setState({
      isLoading: true,
    });
    let findJumpToPart = false;
    if (data.question_list[activePage].jump_to_part) {
      findJumpToPart = data.question_list[activePage].jump_to_part;
    } else {
      let findJumpLv1 = values.questions.find(
        (e) => e.type === "1" && e.answer,
      );
      if (findJumpLv1) {
        let findAns = findJumpLv1.answer_list.find(
          (f) => f.ans === findJumpLv1.answer,
        );
        if (findAns.jump_to_part) {
          findJumpToPart = findAns.jump_to_part;
        }
      }
    }
    switch (router.params.action) {
      case "view":
        if (activePage + 1 < data.question_list.length) {
          setTimeout(() => {
            this.setState({
              tempValues: [..._updateTemp(tempValues, values, findJumpToPart)],
              activePage: !findJumpToPart ? activePage + 1 : findJumpToPart - 1,
              isLoading: false,
            });
          }, 400);
        } else {
          toast.success(this.props.t("Successfully registered", { ns: "common" }));
          this.handleNext();
        }
        break;
      case "update":
        let params = {
          activity_form_history_id: router.params?.question_id,
          page: data.question_list[activePage].page,
          questions: values.questions,
        };
        let res = isNoMember
          ? await userService.POST_ACTIVITY_FORM_HISTORY_SUBMIT_ANS_NO_MEMBER(
              params,
            )
          : await userService.POST_ACTIVITY_FORM_HISTORY_SUBMIT_ANS(params);
        if (res && res.status === 200) {
          if (activePage + 1 < data.question_list.length) {
            this.setState({
              tempValues: [..._updateTemp(tempValues, values, findJumpToPart)],
              activePage: !findJumpToPart ? activePage + 1 : findJumpToPart - 1,
              isLoading: false,
            });
          } else {
            toast.success(this.props.t("Preliminary data saved", { ns: "common" }));
            this.handleNext();
          }
        } else {
          // ไม่มี else มาก่อน พอ save ไม่ผ่านจะค้างหน้า loading ตลอด
          this.setState({ isLoading: false });
          if (res?.data?.error?.code === "ACTIVITY_FORM_DRAFT_EXPIRED") {
            this.handleExpired();
          } else {
            toast.error(this.props.t("Submitted failed", { ns: "common" }));
          }
        }
        break;
      default:
        break;
    }
  };

  handleNext = () => {
    const { router } = this.props;
    const locationSplit = router.location.pathname.split("/");
    const isNoMember = !locationSplit.some((e) => e === "system");
    this.props.router.navigate(
      `${
        isNoMember
          ? ROUTE_PATH.ACTIVITY_FORM_NO_LOGIN
          : ROUTE_PATH.ACTIVITY_FORM
      }/${router.params?.id}/quiz/${router.params?.question_id}/${
        router.params.action
      }/preview`,
    );
    // this.props.router.navigate(
    //   `${ROUTE_PATH.ACTIVITY_FORM}/${router.params?.id}/quiz/${router.params?.question_id}/thank-you`
    // );
  };

  render() {
    const { t, router } = this.props;
    const {
      isBgLoading,
      isLoading,
      activePage,
      data,
      initialValue,
      tempValues,
      step,
    } = this.state;

    const renderQuestion = !data
      ? false
      : tempValues && tempValues[activePage]
        ? tempValues[activePage]
        : initialValue && initialValue.question_list.length > 0
          ? initialValue.question_list[activePage]
          : data.question_list[activePage];
    const locationSplit = router.location.pathname.split("/");
    const isNoMember = !locationSplit.some((e) => e === "system");
    return (
      <ActivityFormQuizContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={[
            {
              name: t("Home", { ns: "common" }),
              path: ROUTE_PATH.HOME,
            },
            {
              name: t("Activities", { ns: "common" }),
              path: ROUTE_PATH.ACTIVITIES,
            },
          ]} />
        </div>
        {!isNoMember && (
          <div className="header_back_home_layout">
            <HeaderBackHomeWidget />
          </div>
        )}
        {isLoading ? (
          <Displays.Loading />
        ) : !data.is_active ? (
          <div className="body_layout">
            <div className="activity_expired_label">
              {t("Registration for this event is not open yet", {
                ns: "activity",
              })}
            </div>
          </div>
        ) : (
          <div className="body_layout">
            {step === 1 &&
              (isNoMember ? (
                <ActivityFormQuizNoMemberContainer
                  onSubmit={this.handlePersonalSubmit}
                />
              ) : (
                <>
                  <div className="header_question_layout">
                    <div className="title">
                      {t("Please fill in the details of the main applicant.", {
                        ns: "activity",
                      })}
                    </div>
                    <div className="desc">
                      {t(
                        "In the case of applying as a group or representative, please fill in the Team leader, parent or teacher.",
                        { ns: "activity" },
                      )}
                    </div>
                  </div>
                  <div className="quiz_container_layout">
                    <Forms.PersonalInfoForm
                      isFormDisabled={router.params?.question_id !== "create"}
                      currentPage={activePage + 1}
                      totalPage={data.question_list.length}
                      initialValue={initialValue}
                      onBack={this.handleBack}
                      onSubmit={this.handlePersonalSubmit}
                    />
                  </div>
                </>
              ))}
            {step === 2 && (
              <>
                <div className="header_question_layout">
                  <div className="title">{renderQuestion.title}</div>
                  <div className="desc">{renderQuestion.desc}</div>
                </div>
                <div className="quiz_container_layout">
                  <Forms.QuickTestActivityForm
                    isDisabledForm={router.params.action === "view"}
                    currentPage={activePage + 1}
                    totalPage={data.question_list.length}
                    initialValue={{ questions: renderQuestion.questions }}
                    onBack={this.handleBack}
                    onSubmit={this.handleSubmit}
                  />
                </div>
              </>
            )}
          </div>
        )}
      </ActivityFormQuizContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withTranslation(["common", "activity", "profile"])(
    withRouter(ActivityFormQuizContainer),
  ),
);
